import { render, staticRenderFns } from "./ValidarDocumento.vue?vue&type=template&id=ed377dac&lang=pug&"
import script from "./ValidarDocumento.vue?vue&type=script&lang=js&"
export * from "./ValidarDocumento.vue?vue&type=script&lang=js&"
import style0 from "./ValidarDocumento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports